/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '@app/axios/axiosIns'
import { APP_AUTH_ACCESS_KEY, APP_AUTH_REFRESH_KEY } from '@app/constant/constant'
import { appLogout } from '@app/utils/auth'
import { setLocal } from '@app/utils/storage-available'

export const adminLogin = createAsyncThunk('auth/login', async (data: any, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('/auth/login', data)
    if (response?.data?.data) {
      setLocal(APP_AUTH_ACCESS_KEY, response?.data?.data?.access_token)
      setLocal(APP_AUTH_REFRESH_KEY, response?.data?.data?.refresh_token)
    }
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const replaceLogin = createAsyncThunk('auth/replace-login', async (data: any, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('/auth/replace-login', data)
    if (response?.data?.data) {
      setLocal(APP_AUTH_ACCESS_KEY, response?.data?.data?.access_token)
      setLocal(APP_AUTH_REFRESH_KEY, response?.data?.data?.refresh_token)
    }
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const adminLogout = createAsyncThunk('auth/logout', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/auth/logout')
    if (response) {
      appLogout()
    }
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

interface UserState {
  isLoading: boolean
  registeredUser: any
  token: any
  admin: any
  error: any
  isAlreadyLoggedIn: any
}

const initialState: UserState = {
  isLoading: false,
  registeredUser: null,
  token: null,
  admin: null,
  error: null,
  isAlreadyLoggedIn: false
}

const authSlice: any = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetState: () => initialState,
    setAlreadyLoggedIn: (state, { payload }) => {
      state.isAlreadyLoggedIn = payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminLogin.pending, (state) => {
        state.isLoading = true
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(replaceLogin.pending, (state) => {
        state.isLoading = true
      })
      .addCase(replaceLogin.fulfilled, (state, { payload }) => {
        state.isLoading = false
      })
      .addCase(replaceLogin.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(adminLogout.pending, (state) => {
        state.isLoading = true
      })
      .addCase(adminLogout.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(adminLogout.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetState } = authSlice.actions
export default authSlice.reducer
